/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OthersFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return OthersFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<OthersFeatureFlagsWithDefaults>): OthersFeatureFlagsWithDefaults {
        let obj = Object.assign(new OthersFeatureFlagsWithDefaults(), model);
        OthersFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OthersFeatureFlagsWithDefaults>): OthersFeatureFlagsWithDefaults {
        if (!model) return null;
        return OthersFeatureFlagsWithDefaults.newInstance(<OthersFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OthersFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.OthersFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OthersFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, OthersFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    othr_2603_b_handler_hpa_scaling_129247: boolean = false;

    /**
     * Flag's default value
     */
    othr_2603_b_handler_hpa_custom_metric_129247: boolean = false;

    /**
     * Flag's default value
     */
    othr_2603_b_orphaned_job_waiting_recovery_129247: boolean = false;

}
